/**
 * Cookie Script
 * https://wordpress.org/plugins/cookie-script-com/
 */
export const cookieScript = {

	/**
	 * Get the Cookie Script cookie.
	 *
	 * @returns {{statistics: boolean, marketing: boolean, preferences: boolean, necessary: boolean}|null}
	 */
	getConsent: () => {

		let consent = pmw.getCookie("CookieScriptConsent")

		if (!consent) return null

		try {
			consent = JSON.parse(consent)

			// if cookie.categories is not an array, but a string, parse it
			if (typeof consent.categories === "string") consent.categories = JSON.parse(consent.categories)
		} catch (e) {
			pmw.console.log("Cookie Script cookie could not be parsed. Ignoring it.", e)
			return null
		}

		/**
		 * Cookie Script writes the CookieScriptConsent cookie before the visitor has
		 * interacted with the banner, for example to store the googleconsentmap.
		 * Such a cookie carries neither an action nor any categories.
		 * Cookie Script itself only treats "accept" and "reject" as a visitor decision,
		 * so without one of those, and without categories, we must not derive any
		 * consent from the cookie. Otherwise the mere presence of the cookie would
		 * unblock all pixels before the visitor has chosen anything.
		 */
		if (
			!["accept", "reject"].includes(consent.action)
			&& !Array.isArray(consent.categories)
		) {
			pmw.console.log("Cookie Script cookie detected, but the visitor hasn't made a choice yet. Ignoring it.")
			return null
		}

		pmw.console.log("Cookie Script CMP consent detected")

		if (consent.action === "reject") {
			return {
				statistics : false,
				marketing  : false,
				preferences: false,
				necessary  : true,
			}
		}

		if (
			consent.categories
			&& consent.categories.length > 0
		) {

			return {
				statistics : consent.categories.indexOf("performance") >= 0,
				marketing  : consent.categories.indexOf("targeting") >= 0,
				preferences: consent.categories.indexOf("functionality") >= 0,
				necessary  : true,
			}
		}

		// The visitor has decided, but no category has been approved. Deny by default.
		return {
			statistics : false,
			marketing  : false,
			preferences: false,
			necessary  : true,
		}
	},

	/**
	 * Cookie Script
	 * If visitor accepts cookies in Cookie Script unblock the scripts
	 * https://support.cookie-script.com/article/20-custom-events
	 */

	loadEventListeners: () => {

		document.addEventListener("CookieScriptAccept", e => {

			let data = {
				statistics : e.detail.categories.includes("performance"),
				marketing  : e.detail.categories.includes("targeting"),
				preferences: e.detail.categories.includes("functionality"),
				necessary  : true,
			}

			pmw.consent.api.updateSelectively({...data, source: "cmp"})
		}, true)

		document.addEventListener("CookieScriptAcceptAll", () => {
			pmw.consent.api.acceptAll({source: "cmp"})
		}, true)

		document.addEventListener("CookieScriptReject", () => {
			pmw.consent.api.revokeAll({source: "cmp"})
		}, true)
	},
}
